/* tslint:disable */
/* eslint-disable */
/**
 * MedicalOperations API
 * This is an OpenAPI for the MedicalOperations Microservice
 *
 * OpenAPI spec version: 0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 * 
 *
 * @export
 * @interface Medication
 */
export interface Medication {

    /**
     * @type {string}
     * @memberof Medication
     */
    MedicationID: string;

    /**
     * @type {string}
     * @memberof Medication
     */
    TenantID: string;

    /**
     * @type {string}
     * @memberof Medication
     */
    BranchID: string;

    /**
     * @type {string}
     * @memberof Medication
     * @example Paracetamol
     */
    Name: string;

    /**
     * @type {string}
     * @memberof Medication
     * @example Panadol
     */
    Brand: string;

    /**
     * @type {Date}
     * @memberof Medication
     */
    EntryDate: Date;

    /**
     * @type {Date}
     * @memberof Medication
     */
    ExpiryDate: Date;

    /**
     * @type {string}
     * @memberof Medication
     * @example MUO45S
     */
    Code: string;

    /**
     * @type {string}
     * @memberof Medication
     * @example Paracetamol
     */
    ActiveIngredient: string;

    /**
     * @type {string}
     * @memberof Medication
     * @example 500 mg
     */
    Strength: string;

    /**
     * @type {string}
     * @memberof Medication
     * @example America GSK
     */
    Source: string;

    /**
     * @type {string}
     * @memberof Medication
     * @example UC190493
     */
    BatchNumber: string;

    /**
     * @type {string}
     * @memberof Medication
     * @example Liquid
     */
    Type: MedicationTypeEnum;

    /**
     * @type {number}
     * @memberof Medication
     * @example 20.5
     */
    Price: number;

    /**
     * @type {string}
     * @memberof Medication
     * @example Two Pills
     */
    Dose: string;

    /**
     * @type {string}
     * @memberof Medication
     */
    AddedByID: string;
}

/**
 * @export
 * @enum {string}
 */
export enum MedicationTypeEnum {
    Liquid = 'Liquid',
    Pills = 'Pills',
    Drops = 'Drops',
    Orally = 'Orally',
    Inhalation = 'Inhalation',
    Instillation = 'Instillation',
    Injection = 'Injection',
    TransdermalAdministration = 'Transdermal Administration',
    RectalAdministration = 'Rectal Administration',
    VaginalAdministration = 'Vaginal Administration'
}

